// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3cf8fec","239":"77b4b3bf","732":"ee348e38"}[chunkId] + ".chunk.js";
};